// extracted by mini-css-extract-plugin
export default {"Hrline":"style_Hrline__ML9lc","text-label-info":"style_text-label-info__fdbZb","pro-con8":"style_pro-con8__GcLiG"};